import { useRef } from 'react';
import { Input, Select } from 'antd';
import XTable from 'components/XTable';
import { getCheckInChangeListApi, getDownloadApi } from 'api/checkInChange';
import { getFilterText, downFile } from 'utils';
import { nursingAreas } from 'enumeration/nursingAreas';
import { checkIn } from 'enumeration/checkIn';
import moment from 'moment';

const { Option } = Select;

const CheckInChange = () => {
    const xTableRef = useRef();

    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        getDownloadApi(queryValue).then(res => {
            if (res.success) {
                const filename = `变更记录${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };
    const actionBtns = [{ text: '导出记录', onClick: downloadRecord }];

    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
        },
        {
            title: '姓名',
            dataIndex: 'name',
        },
        {
            title: '身份证号',
            dataIndex: 'idNo',
        },
        {
            title: '原护理区',
            dataIndex: 'oriNursingArea',
            render: val => getFilterText(nursingAreas, val),
        },
        {
            title: '现护理区',
            dataIndex: 'nursingArea',
            render: val => getFilterText(nursingAreas, val),
        },
        {
            title: '在院状态',
            dataIndex: 'status',
            render: val => (val ? '在住' : '已出院'),
        },
        {
            title: '操作人',
            dataIndex: 'operator',
        },
        {
            title: '操作时间',
            dataIndex: 'createAt',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
    ];

    const queryItems = [
        {
            formItemApis: {
                label: '身份证号',
                help: null,
                name: 'idNo',
            },
            item: <Input style={{ width: 200 }} allowClear />,
        },
        {
            formItemApis: {
                label: '姓名',
                help: null,
                name: 'name',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '入住状态',
                help: null,
                name: 'status',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {checkIn.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];

    // const downloadRecord = () => {
    //     const queryValue = xTableRef.current.queryForm?.getFieldsValue();
    //     getDownloadCheckApi(queryValue).then(res => {
    //         if (res.success) {
    //             const filename = `入住记录${moment().valueOf()}.xls`;
    //             downFile(res.file, filename);
    //         }
    //     });
    // };

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                actionBtns={actionBtns}
                api={getCheckInChangeListApi}
                rowKey="id"
                ref={xTableRef}
            />
        </div>
    );
};
export default CheckInChange;
